const idOf = (value) => String(value?._id || value || "");
// product.boutiqueId[] = the boutiques (User.boutiques._id) showing this one product.
export const productShopIds = (product) => [...new Set((product?.boutiqueId || []).map(idOf).filter(Boolean))];
export const resolveProductShop = ({ product, currentShopId, selectedShopId } = {}) => {
  const ids = productShopIds(product);
  const summaries = Array.isArray(product?.associatedShops) ? product.associatedShops : [];
  const shops = ids.map((id) => summaries.find((s) => idOf(s) === id) || (product?.associatedShops === undefined ? { _id: id } : null)).filter(Boolean);
  return shops.find((s) => idOf(s) === idOf(selectedShopId)) || shops.find((s) => idOf(s) === idOf(currentShopId)) || shops[0] || null;
};
export const productShopPath = (product, shop) => {
  const owner = product?.owner || product?.provider || product?.providerId;
  const ref = owner?.publicId || owner?._id || owner;
  const prefix = shop?.type === "provider" || product?.providerId ? "/provider-shop/" : "/lakay-ShopSeller/";
  return `${prefix}${encodeURIComponent(ref || "")}${shop?._id ? `?shop=${encodeURIComponent(idOf(shop))}` : ""}`;
};
export const withProductShop = (url, shop) => {
  if (!shop?._id) return url;
  const [path, search = ""] = url.split("?");
  const query = new URLSearchParams(search);
  query.set("shop", idOf(shop));
  return `${path}?${query.toString()}`;
};

export const productWithShopPrice = (product, shop) => {
  const price = (product?.shopPrices || []).find((entry) => String(entry.shopId) === String(shop?._id))?.price ?? shop?.price;
  return price === undefined || price === null ? product : { ...product, price, filterProduct: (product?.filterProduct || []).map((variant) => ({ ...variant, priceFil: price })) };
};
